enum PaymentOptionKey {
  CASH = 1,
  VNPAYQR = 24,
  COOPERATE = 18,
  PAY_BY_CARD = 13,
  MPGS = 23,
}

export { PaymentOptionKey }
